import { Howl, Howler } from "howler";
import { path } from "../settings";

export const audioBundle2 = {
    plus: "Plus.wav",
    minus: "Minus.wav",
    loadingDone: "LoadingDone.mp3",
    play: "Play.mp3",
    tap: "Button_Tap.wav",
    off: "Button_Off.wav",
    disable: "Buttons Disable.wav",
    loseBomb: 'Lose-Bomb.wav',
    cutWin: 'Cut-Win.wav',
    slice1: 'Fruit-Slice-1.wav',
    slice2: 'Fruit-Slice-2.wav',
    slice3: 'Fruit-Slice-3.wav',
    slice4: 'Fruit-Slice-4.wav',
    mainBg: 'bg_default.mp3',
    mainBg1: 'bg_default_1.mp3',
    mainBg2: 'bg_default_2.mp3',
    bgTransition: 'bg_transition.mp3',
    ambient1: 'Ambient-Birds.wav',
    ambient2: 'Ambient-Birds2.wav',
    ambient3: 'Ambient-with Cicada.wav',
    big: 'Bigwin.mp3',
    megaWin: 'Bigwin-Megawin.mp3',
    ultraWin: 'Bigwin-Megawin-Ultrawin.mp3',
    enkC: 'Victory-Enk-C.mp3',
    popupOpen: 'popUpOpen.wav',
    popupClose: 'popUpClose.wav',
    tabChange: 'tabChange.wav',
    mini: 'Victory-Mega-win-Final.mp3',
    mega: 'Victory-Mini-win-Final.mp3',
    ultra: 'Victory-Ultra-win-Final.mp3',
}

// Sounds to keep running
const exceptions = new Set([
    audioBundle2.mainBg,
    audioBundle2.mainBg1,
    audioBundle2.mainBg2,
    audioBundle2.bgTransition,
    audioBundle2.ambient1,
    audioBundle2.ambient2,
    audioBundle2.ambient3,
]);

export function toggleNonBgSounds(soundsPaused) {
    for (const key in audioBundle2) {
        const soundFile = audioBundle2[key];
        const howl = audios[soundFile];
        if (!howl) continue;

        if (!exceptions.has(soundFile)) {
            howl.volume(soundsPaused ? 1 : 0);
        }
    }
}

const audios = {};

export async function loadSounds() {

    try {
        const gameSounds = await loadSoundBundle(audioBundle2, path.sound);
        Object.assign(audios, gameSounds);

        // const victorySounds = await loadSoundBundle(audioBundle, path.victoryAudioPath);
        // Object.assign(audios, victorySounds);

        return audios;
    } catch (error) {
        // console.error("Error loading sounds:", error);
        throw error;
    }
}

function createSoundsArray(audioConstants) {
    return Object.values(audioConstants);
}

const loopedTracks = [audioBundle2.mainBg, audioBundle2.mainBg1, audioBundle2.mainBg2];

async function loadSoundBundle(bundle, path) {
    const sounds = createSoundsArray(bundle);
    const audio = {};

    const promises = sounds.map((sound) => {
        return new Promise((resolve) => {
            const howl = new Howl({
                src: [path + sound],
                volume: 1,
                loop: loopedTracks.includes(sound),
                onload: () => {
                    audio[sound] = howl;
                    resolve();
                },
                onloaderror: (id, error) => {
                    console.warn(`Failed to load sound: ${sound}`, error);
                    resolve();
                },
            });
        });
    });

    await Promise.all(promises);
    return audio;
}

export function getCurrentlyPlayingBg() {
    for (const key of Object.keys(audioBundle2)) {
        if (loopedTracks.includes(audioBundle2[key])) {
            const howl = audios[audioBundle2[key]];
            if (howl && howl.playing()) {
                return key;
            }
        }
    }
    return null;
}

export function playMiniAudio(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.mini)
    else stopSound(audioBundle2.mini)
}

export function playMegaAudio(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.mega)
    else stopSound(audioBundle2.mega)
}

export function playUltraAudio(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.ultra)
    else stopSound(audioBundle2.ultra)
}

export function playMegaWin(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.megaWin)
    else stopSound(audioBundle2.megaWin)
}

export function playBigWin(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.big)
    else stopSound(audioBundle2.big)
}

export function playEnkC(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.enkC)
    else stopSound(audioBundle2.enkC)
}

export function playUltraWin(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.ultraWin)
    else stopSound(audioBundle2.ultraWin)
}

export function playPlus(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.plus)
    else stopSound(audioBundle2.plus)
}

export function playOff(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.off)
    else stopSound(audioBundle2.off)
}

export function playTap(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.tap)
    else stopSound(audioBundle2.tap)
}

export function playPlay(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.play)
    else stopSound(audioBundle2.play)
}

export function playMinus(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.minus)
    else stopSound(audioBundle2.minus)
}

export function playDisable(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.disable)
    else stopSound(audioBundle2.disable)
}

export function playLoadingDone(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.loadingDone)
    else stopSound(audioBundle2.loadingDone)
}

export function playLoseBomb(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.loseBomb)
    else stopSound(audioBundle2.loseBomb)
}

export function playPopupOpen(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.popupOpen)
    else stopSound(audioBundle2.popupOpen)
}

export function playPopupClose(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.popupClose)
    else stopSound(audioBundle2.popupClose)
}

export function playCutWin(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.cutWin)
    else stopSound(audioBundle2.cutWin)
}

export function playTabChange(shouldPlay) {
    if (sfxSound.value && shouldPlay) playSound(audioBundle2.tabChange)
    else stopSound(audioBundle2.tabChange)
}

export function playSlice(shouldPlay) {
    if (sfxSound.value && shouldPlay) {
        const randomNum = Math.floor(Math.random() * 4) + 1;
        const sliceKey = `slice${randomNum}`;
        playSound(audioBundle2[sliceKey]);
    } else {
        stopSound(audioBundle2.cutWin);
    }
}

export function playAmbient(shouldPlay) {
    if (sfxSound.value && shouldPlay) {
        const randomNum = Math.floor(Math.random() * 3) + 1;
        const ambientKey = `ambient${randomNum}`;
        playSound(audioBundle2[ambientKey]);
    } else {
        stopSound(audioBundle2.ambient1);
        stopSound(audioBundle2.ambient2);
        stopSound(audioBundle2.ambient3);
    }
}


export function playTransition(shouldPlay) {
    if (sfxSound.bg && shouldPlay) playSound(audioBundle2.bgTransition)
    else stopSound(audioBundle2.bgTransition)
}

export function playMainBg(shouldPlay) {
    if (sfxSound.bg && shouldPlay) playSound(audioBundle2.mainBg)
    else stopSound(audioBundle2.mainBg)
}

export function playMainBg1(shouldPlay) {
    if (sfxSound.bg && shouldPlay) playSound(audioBundle2.mainBg1)
    else stopSound(audioBundle2.mainBg1)
}

export function playMainBg2(shouldPlay) {
    if (sfxSound.bg && shouldPlay) playSound(audioBundle2.mainBg2)
    else stopSound(audioBundle2.mainBg2)
}

const playSound = (sound) => {
    const howl = audios[sound];
    if (howl) {
        howl.play()
    } else {
        // console.error(`Error playing sound: ${sound}. Sound not loaded.`);
    }
}

const stopSound = (sound) => {
    const howl = audios[sound];
    if (howl) {
        howl.stop()
    } else {
        // console.error(`Error stopping sound: ${sound}. Sound not loaded.`);
    }
}

export function globalVolumes(value) {
    Howler.volume(value);
}

export const sfxSound = {
    _value: true,
    _bg: true,

    get value() {
        return this._value;
    },


    set value(v) {
        this._value = v;
    },

    get bg() {
        return this._bg;
    },

    set bg(v) {
        this._bg = v;
    }
}